var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "verify-content" }, [
    !_vm.translationsLoaded
      ? _c("div", [_c("circle-loader")], 1)
      : _c("div", [
          (_vm.isVerifyEmail && !_vm.isEmailVerified) ||
          (_vm.isVerifyPhone && !_vm.isPhoneVerified)
            ? _c(
                "div",
                { staticClass: "account-page ctsform" },
                [
                  _vm.isVerifyEmail
                    ? _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("Account.VerificationByPin.Email.InfoText") +
                              " "
                          )
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isVerifyPhone
                    ? _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("Account.VerificationByPin.Phone.InfoText") +
                              " "
                          )
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isLoggedIn
                    ? _c("span", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("Account.VerificationByPin.InfoText")
                            ) +
                            " "
                        ),
                        _c(
                          "a",
                          {
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.resendPin()
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("Account.VerificationByPin.Resend"))
                            )
                          ]
                        )
                      ])
                    : _vm._e(),
                  _c("br"),
                  _vm._v(" "),
                  _c("form", { attrs: { id: "confirmEmalByPinForm" } }, [
                    !_vm.isLoggedIn
                      ? _c("div", [
                          _c(
                            "div",
                            {
                              staticClass: "control-block",
                              class: { filled: _vm.userName }
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.trim",
                                    value: _vm.userName,
                                    expression: "userName",
                                    modifiers: { trim: true }
                                  }
                                ],
                                attrs: {
                                  type: "text",
                                  id: "username",
                                  autocomplete: "off",
                                  maxlength: "512",
                                  required: ""
                                },
                                domProps: { value: _vm.userName },
                                on: {
                                  focusout: function($event) {
                                    !_vm.verifyDetails.userName
                                      ? (_vm.errorMessages.userName = true)
                                      : (_vm.errorMessages.userName = false)
                                  },
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.userName = $event.target.value.trim()
                                  },
                                  blur: function($event) {
                                    return _vm.$forceUpdate()
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("label", { staticClass: "control-label" }, [
                                _vm._v(_vm._s(_vm.usernameLabel))
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", [
                            _vm.errorMessages.userName
                              ? _c("div", {
                                  staticClass: "vmsg invalid",
                                  attrs: { id: "err_msg_username" },
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t("Account.Join.ErrorMsg.UserName")
                                    )
                                  }
                                })
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "control-block",
                              class: { filled: _vm.pass }
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.trim",
                                    value: _vm.pass,
                                    expression: "pass",
                                    modifiers: { trim: true }
                                  }
                                ],
                                attrs: {
                                  type: "password",
                                  id: "password",
                                  autocomplete: "off",
                                  maxlength: "64",
                                  required: ""
                                },
                                domProps: { value: _vm.pass },
                                on: {
                                  focusout: function($event) {
                                    !_vm.verifyDetails.pass
                                      ? (_vm.errorMessages.pass = true)
                                      : (_vm.errorMessages.pass = false)
                                  },
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.pass = $event.target.value.trim()
                                  },
                                  blur: function($event) {
                                    return _vm.$forceUpdate()
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("label", { staticClass: "control-label" }, [
                                _vm._v(_vm._s(_vm.$t("Account.Join.Pass")))
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", [
                            _vm.errorMessages.pass
                              ? _c("div", {
                                  staticClass: "vmsg invalid",
                                  attrs: { id: "err_msg_password" },
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t("Account.Join.ErrorMsg.Pass")
                                    )
                                  }
                                })
                              : _vm._e()
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "control-block",
                        class: { filled: _vm.pinCode }
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.pinCode,
                              expression: "pinCode",
                              modifiers: { trim: true }
                            }
                          ],
                          staticClass: "pin-input",
                          attrs: {
                            type: "text",
                            id: _vm.isVerifyEmail ? "pinEmail" : "pinPhone",
                            autocomplete: "off",
                            maxlength: "6",
                            required: ""
                          },
                          domProps: { value: _vm.pinCode },
                          on: {
                            focusout: function($event) {
                              !_vm.verifyDetails.pinCode
                                ? (_vm.errorMessages.pinCode = true)
                                : (_vm.errorMessages.pinCode = false)
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.pinCode = $event.target.value.trim()
                            },
                            blur: function($event) {
                              return _vm.$forceUpdate()
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          { staticClass: "control-label pin-label" },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("Account.VerificationByPin.PIN"))
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", [
                      _vm.errorMessages.pinCode
                        ? _c("div", {
                            staticClass: "vmsg invalid",
                            attrs: {
                              id: _vm.isVerifyEmail
                                ? "err_msg_pinEmail"
                                : "err_msg_pinPhone"
                            },
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t(
                                  "Account.VerificationByPin.ErrorMsg.PinCode"
                                )
                              )
                            }
                          })
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-actions" },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              color: "success",
                              type: "submit",
                              "x-large": "",
                              id: _vm.isVerifyEmail
                                ? "btn_verifyByPinEmail"
                                : "btn_verifyByPinPhone"
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.verifyByPIN()
                              }
                            }
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("Account.VerificationByPin.Verify")
                                )
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "ProcessingDialog",
                    {
                      attrs: {
                        isDialogPersistent: true,
                        isProcessing: _vm.isProcessing,
                        isSuccess: !_vm.transactionError,
                        processingTitle: _vm.processingTitle,
                        processingText: _vm.processingText,
                        successTitle: _vm.successTitle,
                        successText: _vm.successText,
                        errorTitle: _vm.errorTitle,
                        closeBtnText: _vm.$t("ProcessingDialog.CloseButtonText")
                      },
                      on: { close: _vm.closeVerificationDialog },
                      model: {
                        value: _vm.dialog,
                        callback: function($$v) {
                          _vm.dialog = $$v
                        },
                        expression: "dialog"
                      }
                    },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "text-error" }, slot: "text-error" },
                        [
                          _c(
                            "p",
                            { staticClass: "generic-icon-note" },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "mr-1",
                                  attrs: { color: "error" }
                                },
                                [_vm._v("error")]
                              ),
                              _c("span", [_vm._v(_vm._s(_vm.errorText))])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("p", { staticClass: "response-error" }, [
                            _vm._v(_vm._s(_vm.transactionError))
                          ]),
                          _vm._v(" "),
                          _c("p", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t(
                                  "Account.Join.Dialog.Error.Text.ContactSupport"
                                )
                              )
                            }
                          })
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-12dc9472", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12dc9472","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/IntegratedWallet/VerificationByPin.vue
// module id = null
// module chunks = 